export enum ExternalLinksZIndexes {
    OmgBehindTheGame= 8035,
    //[PRIORITY_LEVEL.GAME_FRAME]: 8040,
    MyAccount = 8060,
    InternalOverExternalLink= 8065,
    Omg = 8070,
    Cashier = 8072,
    GamesQuestionnaire = 8073,
    Membership = 8078,
    /*
    [PRIORITY_LEVEL.BASE]: 8000,
    [PRIORITY_LEVEL.POP_UP]: 8010,
    [PRIORITY_LEVEL.OPEN_SESSION]: 8020,
    [PRIORITY_LEVEL.FP]: 8030,
    [PRIORITY_LEVEL.OMG_BEHIND]: 8035,
    [PRIORITY_LEVEL.GAME_LOADING_INDICATOR]: 8037,
    [PRIORITY_LEVEL.NEXT_GAME]: 8038,
    [PRIORITY_LEVEL.GAME_FRAME]: 8040,
    [PRIORITY_LEVEL.GAME_FRAME_FP]: 8041,
    [PRIORITY_LEVEL.GAME_FRAME_LOADER]: 8042,
    [PRIORITY_LEVEL.MINI_CASHIER]: 8045,
    [PRIORITY_LEVEL.LOGIN]: 8050,
    [PRIORITY_LEVEL.SPAIN_SUMMARY_MESSAGE]: 8055,
    [PRIORITY_LEVEL.EXTERNAL_LINK]: 8060,
    [PRIORITY_LEVEL.INTERNAL_OVER_EXTERNAL_LINK]: 8061,
    [PRIORITY_LEVEL.OMG]: 8070,
    [PRIORITY_LEVEL.CASHIER]: 8072,
    [PRIORITY_LEVEL.GAMES_QUESTIONNAIRE]: 8073,
    [PRIORITY_LEVEL.GEO_FREEZE_WINDOW]: 8074,
    [PRIORITY_LEVEL.TEMP_ACCOUNT]: 8075,
    [PRIORITY_LEVEL.MEMBERSHIP]: 8078,
    [PRIORITY_LEVEL.MESSAGE]: 8080,
    [PRIORITY_LEVEL.SECONDARY_MESSAGE]: 8082,
    [PRIORITY_LEVEL.TOUCH_ID]: 8090,
    [PRIORITY_LEVEL.TOUCH_ID_POPUP]: 9002,
     */
}